

<form 
    pcgSubmitUrl="api/Administration/UserEmploymentInfo/UpdateUserEmploymentInfo" 
    [formGroup]="formGroup"
    (messageSuccess)="onMessageSuccess($event)"
>

    <div class="row">
        <pcg-control-group 
            class="col" 
            label="Role"
        >
            <pcg-select 
                pcgControlRef 
                dataSource="api/Select/JobTitleEnum" 
                formControlName="jobTitle" 
                placeholder="Select a Job Title"
            ></pcg-select>
        </pcg-control-group>

        <pcg-control-group 
            class="col" 
            label="Experience Level"
        >
            <pcg-select 
                pcgControlRef 
                dataSource="api/Select/ExperienceLevelEnum" 
                formControlName="experienceLevel" 
                placeholder="Select Experience Level"
            ></pcg-select>
        </pcg-control-group>

        <pcg-control-group 
            class="col" 
            label="Employment Type"
        >
            <pcg-select 
                pcgControlRef 
                dataSource="api/Select/TypeOfEmployeeEnum" 
                formControlName="typeOfEmployee" 
                placeholder="Select an Employment Type"
            ></pcg-select>
        </pcg-control-group>
    </div>

    <div class="row">
        <div class="col-md-2 mt-2">
            <label 
                for="isTeamLead"
                class="for"
            >Team Lead</label>
            <div class="center">
                <label class="switch">
                    <input 
                        pcgControlRef 
                        type="checkbox" 
                        id="isTeamLead" 
                        formControlName="isTeamLead" 
                    />
                    <span class="slider round"></span>
                </label>
            </div>
        </div>

        @if (formGroup.controls.typeOfEmployee.value == typeOfEmployee.Employee || formGroup.controls.typeOfEmployee.value == typeOfEmployee.SubContracted) {
            <div class="col-md-2 mt-2">
                @if (formGroup.controls.typeOfEmployee.value == typeOfEmployee.Employee) {
                    <label 
                        for="tenNinetyNineReceived"
                        class="for"
                    >W-9 Received</label>
                    <div class="center">
                        <label class="switch">
                            <input 
                                pcgControlRef 
                                type="checkbox" 
                                id="tenNinetyNineReceived" 
                                formControlName="tenNinetyNineReceived" 
                            />
                            <span class="slider round"></span>
                        </label>
                    </div>
                }
                @if (formGroup.controls.typeOfEmployee.value == typeOfEmployee.SubContracted) {
                    <label 
                        for="exemptionFormReceived"
                        class="for"
                    >Exemption Form Received</label>
                    <div class="center">
                        <label class="switch">
                            <input 
                                pcgControlRef 
                                type="checkbox" 
                                id="exemptionFormReceived" 
                                formControlName="exemptionFormReceived" 
                            />
                            <span class="slider round"></span>
                        </label>
                    </div>
                }
            
                @if (iAmMe || isAdmin) {
                    <pcg-control-group 
                        label="Upload File"
                    >
                        <pcg-file-upload 
                            pcgControlRef 
                            formControlName='file' 
                            type="file"
                        ></pcg-file-upload>
                    </pcg-control-group>
                    @if (formGroup.controls.fileName.value != null && formGroup.controls.fileName.value != "") {
                        <div>
                            <a 
                                [href]="'/Uploads/UserFiles/' + formGroup.controls.fileName.value" 
                                rel="noreferrer noopener" 
                                target="_blank" 
                            >View File</a>
                        </div>
                    }
                }
            </div>
        }

        <div class="col-md-2 mt-2">
            <label 
                for="isResponseTrained"
                class="for"
            >Response Trained</label>
            <div class="center">
                <label class="switch">
                    <input 
                        pcgControlRef 
                        type="checkbox" 
                        id="isResponseTrained" 
                        formControlName="isResponseTrained" 
                    />
                    <span class="slider round"></span>
                </label>
            </div>
        </div>

        <div class="col-md-2 mt-2">
            <label 
                for="hasHazMat"
                class="for"
            >HazMat</label>
            <div class="center">
                <label class="switch">
                    <input 
                        pcgControlRef 
                        id="hasHazMat" 
                        type="checkbox" 
                        formControlName="hasHazMat" 
                    />
                    <span class="slider round"></span>
                </label>
            </div>
        </div>

        <pcg-control-group 
            class="col-md-2 mt-2" 
            label="Tours of Duty"
        >
            <input 
                pcgControlRef 
                class="form-control" 
                type="number" 
                inputmode="numeric" 
                pcgNumeric 
                formControlName="toursOfDuty" 
                maxlength="3" 
            />
        </pcg-control-group>
    </div>

    <!-- ERFS Active tooltip -->
    <ng-template #tooltipContent>
        <div class="text-left">
            <b>Active</b> = User is currently in the field responding to an emergency event.<br />
            <b>Standby</b> = User is confirmed available for an event, but has not yet been activated.<br />
            <b>Inactive</b> = User is not Active nor Standby.<br />
            <b>Not Eligible</b> = User is not eligible for ERFS service.
        </div>
    </ng-template>

    <div class="row">
        <pcg-control-group 
            class="col-md-4" 
            [labelTooltip]="tooltipContent" 
            label="Status"
        >
            <pcg-select 
                pcgControlRef 
                dataSource="api/Select/ActiveStatusEnum" 
                formControlName="activeStatus" 
                placeholder="Select a Status"
            ></pcg-select>
        </pcg-control-group>

        <pcg-control-group 
            class="col-md-4" 
            label="Drivers License Class"
        >
            <pcg-select 
                pcgControlRef 
                dataSource="api/Select/DriverLicenseClassEnum" 
                formControlName="driverLicenseClass" 
                placeholder="Select a Drivers License Class"
            ></pcg-select>
        </pcg-control-group>

        <pcg-control-group 
            class="col-md-4" 
            label="Pump Certified"
        >
            <pcg-select 
                pcgControlRef 
                dataSource="api/Select/YesNoSomeEnum" 
                formControlName="pumpCertification" 
                placeholder="Select a Pump Certification Level"
            ></pcg-select>
        </pcg-control-group>
    </div>

    <div class="row">
        <pcg-control-group 
            class='col-md-4 col-lg-2' 
            label='Date Start'
        >
            <input 
                type="date" 
                pcgControlRef 
                formControlName='dateStart' 
                class="form-control form-control-date"
                [ngModel]="formGroup.controls.dateStart.value | date:'yyyy-MM-dd'" 
            />
        </pcg-control-group>

        <pcg-control-group 
            class='col-md-4 col-lg-2' 
            label='Date End'
        >
            <input 
                type="date" 
                pcgControlRef 
                formControlName='dateEnd' 
                class="form-control form-control-date"
                [ngModel]="formGroup.controls.dateEnd.value | date:'yyyy-MM-dd'" 
            />
        </pcg-control-group>
    </div>

    <hr />

    <div class="row">
        <pcg-control-group 
            class="col" 
            label="Vehicle Description"
        >
            <textarea 
                pcgControlRef 
                class="form-control" 
                type="text" 
                formControlName="personalVehicleDescription"
            ></textarea>
        </pcg-control-group>

        <pcg-control-group 
            class="col" 
            label="Notes"
        >
            <textarea 
                pcgControlRef 
                class="form-control" 
                type="text" 
                formControlName="extraNotes"
            ></textarea>
        </pcg-control-group>
    </div>

    <pcg-fixed-buttons>
        <a 
            class='btn btn-cancel btn-lg' 
            backButton="/administration/users"
        >Back</a>
        <button class='btn btn-save btn-lg'>Save</button>
    </pcg-fixed-buttons>
</form>
